import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { AwsCredentialIdentity, Provider } from '@aws-sdk/types';
import { fetchAuthSession } from '@aws-amplify/auth';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';

export class CognitoService {
  private static cachedProvider: ReturnType<typeof fromCognitoIdentityPool> | null = null;
  private static cachedToken: string | null = null;

  private static async getToken(): Promise<string> {
    const currentSession = await fetchAuthSession();
    return <string>currentSession.tokens?.idToken?.toString();
  }

  private static getCognitoDomain(): string {
    return `cognito-idp.${ENVIRONMENT_VARIABLES.env.Region}.amazonaws.com/${ENVIRONMENT_VARIABLES.env.CognitoUserPoolId}`;
  }

  public static async getAWSServiceCredentials() {
    const token = await this.getToken();

    // Reuse cached provider if token hasn't changed
    if (this.cachedProvider && this.cachedToken === token) {
      return this.cachedProvider;
    }

    const COGNITO_LOGIN: { [key: string]: string } = {};
    COGNITO_LOGIN[this.getCognitoDomain()] = token;
    this.cachedProvider = fromCognitoIdentityPool({
      clientConfig: { region: ENVIRONMENT_VARIABLES.env.Region },
      identityPoolId: ENVIRONMENT_VARIABLES.env.CognitoIdentityPoolId,
      logins: COGNITO_LOGIN
    });
    this.cachedToken = token;
    return this.cachedProvider;
  }

  /** Centralized credential provider for all AWS SDK clients. */
  public static readonly credentialProvider: Provider<AwsCredentialIdentity> = async () => {
    const provider = await CognitoService.getAWSServiceCredentials();
    return provider();
  };
}
